document.addEventListener("DOMContentLoaded", function () {
  function openCookiePrefs(e) {
    e.preventDefault();

    if (
      window.privacyBanner &&
      typeof window.privacyBanner.showPreferences === "function"
    ) {
      window.privacyBanner.showPreferences();
      return;
    }
  }

  document.querySelectorAll("a").forEach(function (el) {
    if (el.hash === "#cookie-settings") {
      el.addEventListener("click", openCookiePrefs);
    }
  });
});
